

const state = {
  data: [],
  dataCategory: [],
  dataCategoryType: [],
}

export default state;